import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from './shared/auth.service';

const PUBLIC_ROUTE_PREFIXES = ['/forgot', '/recover', '/download', '/recommendation-letter', '/gallery'];

@Component({
  selector: 'body',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  constructor(
    private router: Router,
    private auth: AuthService,
  ) {}

  private isPublicRoute(pathname: string = location.pathname): boolean {
    return PUBLIC_ROUTE_PREFIXES.some(prefix => pathname.startsWith(prefix));
  }

  ngOnInit() {
    // Check authentication status on app initialization with a small delay
    // to ensure cookies are properly loaded
    setTimeout(async () => {
      if (!this.isPublicRoute()) {
        const isAuthenticated = await this.auth.checkToken();
        // Perform a one-time renew after initial auth check to obtain expiry and schedule future renewals
        if (isAuthenticated) {
          this.auth.renew();
        }
      }
    }, 100);

    this.auth.authenticationState.subscribe(async state => {
      if (state) {
        // User is authenticated, staying on current page
      } else {
        if (!this.isPublicRoute()) {
          this.router.navigate(['login']);
        }
      }
    });

    this.router.events.subscribe(evt => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
    });
  }
}
